import { render, staticRenderFns } from "./getVC.vue?vue&type=template&id=4ac9836b&scoped=true&"
import script from "./getVC.vue?vue&type=script&lang=js&"
export * from "./getVC.vue?vue&type=script&lang=js&"
import style0 from "./getVC.vue?vue&type=style&index=0&id=4ac9836b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac9836b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ac9836b')) {
      api.createRecord('4ac9836b', component.options)
    } else {
      api.reload('4ac9836b', component.options)
    }
    module.hot.accept("./getVC.vue?vue&type=template&id=4ac9836b&scoped=true&", function () {
      api.rerender('4ac9836b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/onboarding/vc/getVC.vue"
export default component.exports